export default "__VITE_ASSET__5$KW_Q9r__"